import { render } from "./ProtectMoney.vue?vue&type=template&id=d95e9304"
import script from "./ProtectMoney.vue?vue&type=script&lang=js"
export * from "./ProtectMoney.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__